import React, { createContext, PropsWithChildren, useState } from 'react';
import { useRouter } from 'next/router';
import { User } from '@/lib/session';

export interface Auth {
  isAuthenticated: boolean;
  user: User | null;
  jwt: string | null;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<Auth>({
  isAuthenticated: false,
  user: null,
  jwt: null,
  logout: async () => {},
});

type Props = {
  user: User | null;
  jwt: string | null;
};

const browserLogout = async () => {
  await fetch('/api/logout', {
    method: 'POST',
    credentials: 'include',
  });
};

const Authentication: React.FC<PropsWithChildren<Props>> = ({ user, jwt, children }) => {
  const [auth, setAuth] = useState({
    user,
    jwt,
  });
  const router = useRouter();

  const logout = async () => {
    try {
      await browserLogout();
      await router.push('/login');
      setAuth({
        user: null,
        jwt: null,
      });
    } catch {
      //
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: !!auth.user,
        ...auth,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default Authentication;
